<dx-popup [visible]="visible$ | async" title="Unstable connection" height="270" width="400" (onHidden)="navigateToParent()">
  <dxi-toolbar-item [toolbar]="'bottom'" [location]="'after'" [widget]="'dxButton'" [options]="{ text: 'Go Home', onClick: goHome }">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'" class="popup-content">
    <dx-scroll-view [useNative]="true">
      <strong>Unstable connection detected. Please try again later when connection becomes stable. If this error persists, please contact Technical Support for assistance. Call 1-800-234-0482.</strong>
    </dx-scroll-view>
  </div>  
</dx-popup>
